package com.parmartechnologies.ui.core.mediaFile.viewModel

import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.core.feature.mediaFile.model.MediaFile
import com.parmartechnologies.core.feature.mediaFile.network.MediaFileRetrieveRequest
import com.parmartechnologies.core.feature.mediaFile.network.MediaFileUploadRequest
import com.parmartechnologies.storage.table.media_file.MediaFileDatabaseTable
import com.parmartechnologies.ui.core.mediaFile.handler.MediaFileHandler
import com.parmartechnologies.ui.core.mediaFile.network.MediaFileNetwork
import com.parmartechnologies.ui.core.mediaFile.repository.MediaFileRepository
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

class MediaFileViewModel(private val repository: MediaFileRepository = MediaFileHandler.shared().repository) :
    AppViewModel() {

    private var job: Job = Job()

    val allData: StateFlow<List<MediaFile>>
        get() = repository.allLiveData

    val selectedData: StateFlow<MediaFile>
        get() = repository.selected

    val createMediaFile: StateFlow<MediaFile>
        get() = repository.createMediaFile

    val mediaFiles: StateFlow<List<MediaFile>>
        get() = repository.mediaFiles

    @OptIn(ExperimentalTime::class)
    val mediaFileLiveData: MutableStateFlow<MediaFile> = MutableStateFlow(MediaFile())
    val mediaFile: StateFlow<MediaFile>
        get() = mediaFileLiveData

    fun loadFor(featureObjectID: String, completion: (ArrayList<MediaFile>) -> Unit) {
//        scope.launch {
//            val mediaFiles = DatabaseHandler.shared().database.mediaFileDao().itemFor(featureObjectID)
//            if(mediaFiles.isNotEmpty()){
//                completion(mediaFiles as ArrayList<MediaFile>)
//            }else{
//                retrieveFor(featureObjectID)
//            }
//        }
    }

    fun find(featureObjectID: String): String {
        var stringToReturn = ""
        allData.value.forEach { item ->
            if (item.FeatureObjectID == featureObjectID && !item.FileURL.isNullOrEmpty()) {
                stringToReturn = item.FileURL
            }
        }
        return stringToReturn
    }

    fun loadMedia(id: String, completion: (MediaFile?) -> Unit) {
        MediaFileDatabaseTable().find(id) { data ->
            if (data != null) {
                completion(data)
            } else {
                retrieveFor(id, completion)
            }
        }
    }

    @OptIn(ExperimentalTime::class)
    fun uploadImage(
        fileString: String,
        featureObjectID: String,
        userId: String,
        businessId: String,
        completion: ((MediaFile?) -> Unit) = {}
    ) {
        if (fileString.isNotBlank()) {
            val unixTime = Clock.System.now().epochSeconds
            val fileName = "${featureObjectID}_$unixTime.png"

            startLoading()
            val request =
                MediaFileUploadRequest(
                    unixTime,
                    userId,
                    businessId,
                    featureObjectID,
                    fileName,
                    fileString
                )
            MediaFileNetwork().upload(request) {
                stopLoading()
                if (it?.payload?._id?.isNotEmpty() == true) {
                    MediaFileDatabaseTable().insert(it.payload) {
                        completion(it.payload)
                    }
                } else {
                    completion(null)
                }
            }
        }
    }

    private fun retrieveFor(id: String, completion: ((MediaFile?) -> Unit) = {}) {
        val request = MediaFileRetrieveRequest("", id)
        MediaFileNetwork().retrieve(request) {
                if (it?.payload?.isEmpty() == true) {
                    completion(null)
                } else {
                    completion(it?.payload?.first())
                }
            MediaFileDatabaseTable().insert(it?.payload){}
        }
    }

    fun retrieve(businessId: String,completion: (() -> Unit) = {}) {
        if (businessId.isEmpty()) {
            return
        }
        val request = MediaFileRetrieveRequest(businessId)
        MediaFileNetwork().retrieve(request) { response ->
            MediaFileDatabaseTable().insert(response?.payload) {
            }
        }
    }
    fun retrieveForBusiness(id:String) {
        val request = MediaFileRetrieveRequest(id)
        MediaFileNetwork().retrieve(request) { response ->
            MediaFileDatabaseTable().insert(response?.payload) {
            }
        }
    }

    fun retrieveForUser(businessId: String,completion: (() -> Unit) = {}) {
        if (businessId.isEmpty()) {
            return
        }
        val request = MediaFileRetrieveRequest(businessId)
        MediaFileNetwork().retrieve(request) {
            if (!it?.payload.isNullOrEmpty()) {
                scope.launch {
                    repository.liveData.emit(it!!.payload)
                }
            }
        }
    }
//
//    fun createNew(request:JSONObject) {
//        val unixTime = System.currentTimeMillis()
//        request.put(KeyConstant.uniqueId,unixTime)
//        SocketService.shared().send(MediaFileEvent.CREATE, request)
//    }
//
//    fun insert(newData : MediaFile){
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.mediaFileDao().insert(newData)
//        }
//    }
}